import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';

import { OfflineService } from '../services/offline.service';
import { ConnectionService } from '../services/connection.service';

@Injectable()
export class OfflineGuard implements CanActivate {
  constructor(
    private offlineService: OfflineService,
    private connectionService: ConnectionService,
    private router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    if (!this.connectionService.isOnline) {
      this.router.navigate(['/offline']);
      this.offlineService.showOfflineModal();
      return of(false);
    }
    return of(true);
  }
}
